import { Injectable } from "@angular/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ConfirmService {
  constructor(private modal: NzModalService) {}

  /**
   * Opens a reusable confirmation modal.
   * @param title - Title of the confirmation box
   * @param content - Optional message/content
   * @param okText - Text for OK button (default: "OK")
   * @param cancelText - Text for Cancel button (default: "Cancel")
   * @returns Observable<boolean> that emits true if OK clicked, false if cancelled
   */
  confirm(
    title: string,
    content?: string,
    okText: string = "OK",
    cancelText: string = "Cancel"
  ): Observable<boolean> {
    return new Observable((observer) => {
      const modalRef = this.modal.confirm({
        nzTitle: title,
        nzContent: content || "",
        nzOkText: okText,
        nzCancelText: cancelText,
        nzClassName: "confirmation-modal",
        nzOnOk: () => {
          observer.next(true);
          observer.complete();
        },
        nzOnCancel: () => {
          observer.next(false);
          observer.complete();
        },
      });
    });
  }
}
